import {PriceFunc, PriceElemsData, PriceSegment, getListPrice} from '@icc/price';
import { CustomPricesRecords } from '@icc/shared/custom-price/CustomPrice';
import {APP_CONFIG, AppConfig, AppConfigFactory} from '@icc/shared/config';;
import {Injectable, Inject} from '@angular/core';
import { Common } from '@icc/shared/helpers';
import { core } from '@icc/shared/helpers';
import { Components } from '@icc/window-door/types';


/**
 * Fabryka dopłat za klamki.
 * @param {object} IccConfig IccConfig
 * @return {object} Fabryka.
 */
@Injectable()
export class PriceHandlesService {

    constructor(@Inject(APP_CONFIG) private config: AppConfigFactory) {}

    /**
     * Wylicza dopłatę za klamkę w danym kolorze.
     */
    // eslint-disable-next-line max-statements
    suppHandle(PriceElems, NoPriceCauses, listPrice = false, {sash, handleCustomPrice}: {sash, handleCustomPrice: CustomPricesRecords}, system): PriceSegment {
        const listPriceEnableInMarket = this.config().IccConfig.Offer.listPrice ? this.config().listPriceEnableInMarket : true;

        if (sash.handle && Common.isObject(sash.handleColor) && Common.isObject(sash.handle.colors_prices)
            && Common.isDefined(sash.handle.colors_prices[sash.handleColor.id])
            && (sash.handle.handle_type === 'innerLever'
                || ['doubleLever', 'doubleKnob', 'leverKnob', 'pull'].indexOf(sash.handle.handle_type) > -1
                    && sash.handleOuter && Common.isObject(sash.handleOuterColor) && Common.isObject(sash.handleOuter.colors_prices)
                    && Common.isDefined(sash.handleOuter.colors_prices[sash.handleOuterColor.id])
            )
        ) {
            let price = 0;
            let priceInner = getListPrice(sash.handle, 'colors_prices', listPrice, listPriceEnableInMarket, null, sash.handleColor.id);
            if (Common.isObject(handleCustomPrice) && handleCustomPrice[sash.handle.id]) {
                priceInner = handleCustomPrice[sash.handle.id].getPrice('WindowHandlesColor', sash.handleColor.id);
            }

            if (sash.handle.handle_type === 'innerLever'
                || ['doubleLever', 'doubleKnob', 'leverKnob', 'pull'].indexOf(sash.handle.handle_type) > -1
                    && ~~sash.handle.id === ~~sash.handleOuter.id
                    && ~~sash.handleColor.id === ~~sash.handleOuterColor.id
                    && !this.config().IccConfig.Configurators.separateHandles
            ) {
                if (!sash.handle.price_only_for_second_color) {
                    price = parseFloat(priceInner);
                }
            } else {
                let priceOuter = getListPrice(sash.handleOuter, 'colors_prices', listPrice, listPriceEnableInMarket, null, sash.handleOuterColor.id);
                if (Common.isObject(handleCustomPrice) && handleCustomPrice[sash.handleOuter.id]) {
                    priceOuter = handleCustomPrice[sash.handleOuter.id].getPrice('WindowHandlesColor', sash.handleOuterColor.id, 'price');
                }
                if (this.config().IccConfig.Configurators.handlesSetHalfPrice) {
                    price = (parseFloat(priceInner) + parseFloat(priceOuter)) / 2;
                } else {
                    if (sash.handle.price_only_for_second_color || sash.handleOuter.price_only_for_second_color) {
                        price = parseFloat(priceInner) >= parseFloat(priceOuter) ? parseFloat(priceInner) : parseFloat(priceOuter);
                    } else {
                        price = parseFloat(priceInner) + parseFloat(priceOuter);
                    }
                }
            }

            price += parseFloat(getListPrice(sash.handle, 'price_for_assembly', listPrice, listPriceEnableInMarket)) || 0;

            if(Number(sash.handle.id) !== Number(system.default_window_handler_id) && system.price_for_change_default_handle) {
                price += Number(getListPrice(system, 'price_for_change_default_handle', listPrice, listPriceEnableInMarket));
            }
            if(system.default_handler_price_in_raster) {
                price -= Number(system.default_handler_price);
            }
            if(!this.config().IccConfig.Configurators.sliding_door.outerHandles) {
                PriceElems.handles.push({
                    id            : sash.handle?.id,
                    idOuter       : sash.handleOuter?.id,
                    sashId        : sash.id,
                    sashIndex     : sash.index,
                    name          : sash.handle?.name,
                    nameOuter     : sash.handleOuter?.name,
                    price         : price,
                    colorName     : sash.handleColor?.name,
                    outerColorName: sash.handleOuterColor?.name,
                });
                return {
                    type: 'handles',
                    baseValue: price,
                    value: price,
                    valueType: 'value',
                    data: {
                        id            : sash.handle?.id,
                        idOuter       : sash.handleOuter?.id,
                        sashId        : sash.id,
                        sashIndex     : sash.index,
                        name          : sash.handle?.name,
                        nameOuter     : sash.handleOuter?.name,
                        colorName     : sash.handleColor?.name,
                        outerColorName: sash.handleOuterColor?.name
                    }
                };
            } else {
                PriceElems.handles.push({
                    id            : sash.handle.id,
                    sashId        : sash.id,
                    sashIndex     : sash.index,
                    name          : sash.handle.name,
                    price         : price,
                    colorName     : sash.handleColor.name,
                });
                return {
                    type: 'handles',
                    baseValue: price,
                    value: price,
                    valueType: 'value',
                    data: {
                        id            : sash.handle.id,
                        sashId        : sash.id,
                        sashIndex     : sash.index,
                        name          : sash.handle.name,
                        colorName     : sash.handleColor.name,
                    }
                };
            }
        } else {
            NoPriceCauses.push('no handle in sash');
            return {
                type: 'handles',
                baseValue: null,
                value: null,
                valueType: 'value',
                data: {
                    sashId: sash.id
                }
            };
        }
    }

    suppHandleOuter(PriceElems, NoPriceCauses, listPrice = false, {sash, handleCustomPrice}: {sash, handleCustomPrice: CustomPricesRecords}, system): PriceSegment {
        if (sash.handleOuter && Common.isObject(sash.handleOuterColor) && Common.isObject(sash.handleOuter.colors_prices)
            && Common.isDefined(sash.handleOuter.colors_prices[sash.handleOuterColor.id])
            && this.config().IccConfig.Configurators.sliding_door.outerHandles
        ) {
            let price = 0;
        const listPriceEnableInMarket = this.config().IccConfig.Offer.listPrice ? this.config().listPriceEnableInMarket : true;

            let priceOuter = getListPrice(sash.handleOuter, 'colors_prices', listPrice, listPriceEnableInMarket, null, sash.handleOuterColor.id);
            if (Common.isObject(handleCustomPrice) && handleCustomPrice[sash.handleOuter.id]) {
                priceOuter = handleCustomPrice[sash.handleOuter.id].getPrice('WindowHandlesColor', sash.handleOuterColor.id, 'price');
            }
            price += parseFloat(priceOuter) || 0;


            PriceElems.handles.push({
                id: sash.handleOuter.id,
                sashId: sash.id,
                sashIndex: sash.index,
                name: sash.handleOuter.name,
                price,
                colorName: sash.handleOuterColor.name,
            });
            return {
                type: 'handlesOuter',
                baseValue: price,
                value: price,
                valueType: 'value',
                data: {
                    id            : sash.handleOuter.id,
                    sashId        : sash.id,
                    sashIndex     : sash.index,
                    name          : sash.handleOuter.name,
                    colorName     : sash.handleOuterColor.name,
                }
            };
        } else {
            PriceElems.handles.push({
                sashId: sash.id,
                sashIndex: sash.index,
                price: 0,
            });
            return {
                type: 'handlesOuter',
                baseValue: 0,
                value: 0,
                valueType: 'value',
                data: {
                    sashId        : sash.id,
                    sashIndex     : sash.index,
                }
            };
        }
    }

    /**
     * Doplicza dopłatę za klamki.
     */
    @PriceFunc({
        shortName: 'handles',
        data: {
            sashes           : 'conf.Sashes',
            fitting          : 'conf.Fitting',
            system           : 'conf.System',
            dividers         : 'conf.Mullions',
            handleCustomPrice: 'price.WindowAccessory',
            systemCustomPrice: 'price.WindowLine',
            components: 'conf.Components',
        }
    })
    suppHandles({PriceElems, NoPriceCauses, listPrice}: PriceElemsData,
        {sashes, fitting, system, dividers, handleCustomPrice, systemCustomPrice, components}: {sashes; fitting; system; dividers; handleCustomPrice; systemCustomPrice; components: Components}
    ): PriceSegment[] {
        const priceSegments: PriceSegment[] = [];
        if(components && !components.hardware) {
            return [];
        }
        sashes.filter(sash => ['F', 'FF', 'OFF', 'DS', 'ODS', 'DSC', 'DRP', 'DOP', 'OF'].indexOf(sash.type.type) === -1).forEach(sash => {
            if (Common.isUndefined(sash.handle)
                || (Common.isArray(sash.handle.window_fittings_ids)
                && Common.isObject(fitting)
                && (
                    sash.handle.window_fittings_ids.indexOf(fitting.id) === -1
                    && !this.config().IccConfig.Configurators.selectHandleOnChangeFitting
                ))
            ) {
                NoPriceCauses.push('handle no match to fitting');
                priceSegments.push({
                    type     : 'handles',
                    baseValue: null,
                    value    : null,
                    valueType: 'value',
                    data     : {}
                });
            } else {
                priceSegments.push(this.suppHandle(PriceElems, NoPriceCauses, listPrice, {sash, handleCustomPrice}, system));
                priceSegments.push(this.priceHandleHeight(sash, system, dividers, PriceElems, NoPriceCauses, systemCustomPrice, listPrice));
                priceSegments.push(this.suppHandleOuter(PriceElems, NoPriceCauses, listPrice, {sash, handleCustomPrice}, system));
            }
        });
        return priceSegments;
    }


    /**
     * Zwraca dopłatę za zmianę wysokości klamki.
     *
     * @return {number} Dopłata za zmianę wysokości klamki
     */
    priceHandleHeight(sash, system, dividers, PriceElems, NoPriceCauses, systemCustomPrice: CustomPricesRecords, listPrice = false): PriceSegment {
        if (!sash.defaultHandleHeight && ((sash.type.handle_position !== 'T' && sash.type.type === 'K') || sash.type.type !== 'K')) {
            let divLeft  = <any>core.fIdO(dividers, sash.nearMullions.left);
            let divRight = <any>core.fIdO(dividers, sash.nearMullions.right);
            const listPriceEnableInMarket = this.config().IccConfig.Offer.listPrice ? this.config().listPriceEnableInMarket : true;

            let price    = getListPrice(system, 'handle_change_price', listPrice, listPriceEnableInMarket) * 1;
            if (Common.isObject(systemCustomPrice) && systemCustomPrice[system.id]) {
                price = systemCustomPrice[system.id].getPrice('handle_change_price');
            }
            if (sash.handleHeightType === 'nonstandard') {
                price = NaN;
            }

            if (this.config().IccConfig.Configurators.price.doubleHandleDS
                && (sash.type.handle_position === 'L' && divLeft && divLeft.div && divLeft.div.type === 'false_mullion'
                || sash.type.handle_position === 'R' && divRight && divRight.div && divRight.div.type === 'false_mullion')
            ) {
                price += price;
            }

            PriceElems.handlesHeights.push({
                height   : sash.rHandleY,
                sashId   : sash.id,
                sashIndex: sash.index,
                price    : price
            });
            if (!isNaN(price)) {
                return {
                    type     : 'handlesHeights',
                    baseValue: price,
                    value    : price,
                    valueType: 'value',
                    data     : {
                        height   : sash.rHandleY,
                        sashId   : sash.id,
                        sashIndex: sash.index,
                    }
                };
            } else {
                if (sash.handleHeightType === 'nonstandard') {
                    NoPriceCauses.push('nonstandard handle height');
                } else {
                    NoPriceCauses.push('no handle height price');
                }
                return {
                    type     : 'handlesHeights',
                    baseValue: null,
                    value    : null,
                    valueType: 'value',
                    data     : {
                        height   : sash.rHandleY,
                        sashId   : sash.id,
                        sashIndex: sash.index,
                    }
                };
            }
        } else {
            PriceElems.handlesHeights.push({
                height   : sash.rHandleY,
                sashId   : sash.id,
                sashIndex: sash.index,
                price    : 0
            });
        }
        return {
            type     : 'handlesHeights',
            baseValue: 0,
            value    : 0,
            valueType: 'value',
            data     : {
                height   : sash.rHandleY,
                sashId   : sash.id,
                sashIndex: sash.index,
            }
        };
    }
}
